import styled from 'styled-components'

export const FloatingWhiteWrapper = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 24px;
  margin: 60px auto 24px;
  display: flex;
  ${({ admin }) => admin
    ? ''
    : `
        min-width: 70%;
        @media(max-width: 1350px) { min-width: 80%; }
        @media(max-width: 1200px) { min-width: 90%; }
        @media(max-width: 1100px) { min-width: 95%; }
        @media(max-width: 1000px) { flex-direction: column; }
      `}
  
`

export const ProfileWrapper = styled.div`
  padding: 24px;
  ${({ admin }) => admin
  ? ''
  : `
        border-right: 1px solid rgba(0,0,0,.1);
        width: 50%;
        @media(max-width: 1000px) {
          width: 100%;
          border-right: none;
          text-align: center;
          .buttons {
            justify-content: center;
          }
        }
      `}
`

export const ListWrapper = styled.div`
  padding: 24px;
  width: 50%;
  @media(max-width: 1000px) {
    width: 100%;
    justify-content: center;
  }
`

export const FormButton = styled.div`
  display: flex;
  gap: 8px;
`

export const List = styled.div`
  min-width: 160px;
  ${({ left }) => left ? 'margin-right: 32px;' : ''}
`

export const ListTitle = styled.div`
  background: ${({ brand }) => brand ? 'var(--dark)' : 'var(--primary)'};
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
`

export const ListItem = styled.div`
  padding: 6px 8px 6px 0px;
  border-bottom: 1px solid rgba(0,0,0,.1);
  display: flex;
`

export const Circle = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ active }) => active ? 'var(--primary)' : ''};
  margin: auto 8px auto 4px;
`
